import { useAuthStore } from '@school-manage/context/useAuthStore';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (useAuthStore.getState().authData) {
      throw redirect({
        replace: true,
        to: '/home',
      });
    }

    throw redirect({
      replace: true,
      to: '/login',
    });
  },
});
